{
  "common": {
    "save": "Guardar",
    "saving": "Guardando...",
    "cancel": "Cancelar"
  },
  "header": {
    "title": "Gamificación del área de miembros",
    "subtitle": "Configura la gamificación de tu área de miembros",
    "tabs": {
      "points": "Puntuación",
      "levels": "Niveles",
      "tasks": "Tareas"
    }
  },
  "toggle": {
    "label": "Activar gamificación",
    "enabled": "¡Gamificación activada!",
    "disabled": "¡Gamificación desactivada!",
    "error": "Error al actualizar la configuración"
  },
  "points": {
    "title": "Configura la puntuación predeterminada para cada disparador de la gamificación",
    "unit": "Pts.",
    "saveSuccess": "¡Configuración guardada correctamente!",
    "saveError": "Error al guardar la configuración",
    "actions": {
      "lessonCompleted": "Clase completada",
      "courseStarted": "Curso iniciado",
      "course25Percent": "Curso completado al 25%",
      "course50Percent": "Curso completado al 50%",
      "course75Percent": "Curso completado al 75%",
      "courseCompleted": "Curso completado",
      "dailyLogin": "Inicio de sesión",
      "lessonFavorited": "Clase marcada como favorita",
      "commentPosted": "Mensaje publicado",
      "certificateEarned": "Certificado emitido",
      "challengeActivityCompleted": "Actividad del reto completada",
      "challengeMissionCompleted": "Misión del reto completada",
      "challengeCompleted": "Reto completado",
      "communityPostCreated": "Misión: crear publicación",
      "communityCommentCreated": "Misión: comentar",
      "communityPostLiked": "Misión: dar me gusta"
    }
  },
  "levels": {
    "title": "Configura los niveles de tu gamificación",
    "create": "Crear nivel",
    "table": {
      "level": "Nivel",
      "points": "Puntuación",
      "color": "Color",
      "reward": "Recompensa"
    },
    "rewardsConfigured_one": "{{count}} recompensa configurada",
    "rewardsConfigured_zero": "{{count}} recompensas configuradas",
    "rewardsConfigured_other": "{{count}} recompensas configuradas",
    "edit": "Editar",
    "delete": "Eliminar",
    "deleteConfirm": {
      "title": "Eliminar nivel",
      "description": "¿Seguro que quieres eliminar este nivel?",
      "confirm": "Eliminar"
    },
    "deleteSuccess": "¡Nivel eliminado correctamente!",
    "deleteError": "Error al eliminar el nivel",
    "empty": {
      "title": "Ningún nivel configurado",
      "description": "Empieza creando tu primer nivel",
      "create": "Crear nivel"
    }
  },
  "tasks": {
    "title": "Tareas próximamente",
    "description": "La funcionalidad de tareas estará disponible en una próxima actualización."
  },
  "explanation": {
    "button": "Explicación para los alumnos",
    "dialogTitle": "Explicación para los alumnos",
    "dialogDescription": "Este texto se mostrará a los alumnos en la página de ranking, explicando cómo funciona la gamificación.",
    "placeholder": "Escribe la explicación sobre cómo funciona la gamificación...",
    "saveSuccess": "¡Texto de explicación guardado!",
    "saveError": "Error al guardar el texto",
    "defaultText": "¡Bienvenido a la gamificación de nuestra plataforma!\n\nEn nuestra comunidad hemos implementado un sistema de puntuación para reconocer y recompensar la participación de los miembros. Gracias a esta gamificación, tendrás la oportunidad de ganar puntos y medallas, subir de nivel y conseguir recompensas increíbles.\n\nA continuación tienes la tabla de puntuación que utilizamos:\n\n• Clase completada: al completar una clase, recibirás 10 puntos.\n• Curso iniciado: empezar un curso también te garantiza 50 puntos.\n• Alcanzar el 25% de un curso: cuando alcances el 25% de progreso en un curso, recibirás 20 puntos.\n• Alcanzar el 50% de un curso: al llegar a la mitad del curso, ganarás 30 puntos adicionales.\n• Alcanzar el 75% de un curso: al alcanzar el 75% de un curso, se te recompensará con 50 puntos.\n• Curso completado: completar un curso entero te dará 100 puntos.\n• Certificado emitido: cuando obtengas un certificado, recibirás una bonificación de 100 puntos.\n• Marcar una clase como favorita: marcar una clase como favorita te otorgará 5 puntos.\n• Inicio de sesión diario: solo con iniciar sesión en la plataforma ya consigues 5 puntos.\n• Mensaje publicado: cada vez que publiques un mensaje en el foro o en la comunidad, recibirás 5 puntos.\n\nNos emociona presentarte nuestros seis niveles de gamificación:\n\n→ Nivel 1: para alcanzar el primer nivel, necesitas acumular 1 punto.\n→ Nivel 2: para alcanzar el segundo nivel, necesitas acumular 500 puntos.\n→ Nivel 3: para alcanzar el tercer nivel, necesitas acumular 1.000 puntos.\n→ Nivel 4: para alcanzar el cuarto nivel, necesitas acumular 2.000 puntos.\n→ Nivel 5: para alcanzar el quinto nivel, necesitas acumular 3.000 puntos.\n→ Nivel 6: para alcanzar el sexto y último nivel, necesitas acumular 4.000 puntos.\n\nSigue de cerca tus logros y tu progreso directamente en tu perfil, porque nuestra comunidad valora tu participación y quiere animarte a explorar todo el potencial que te ofrecemos. La gamificación es una forma divertida y motivadora de participar en la plataforma mientras aprendes, compartes conocimientos y conectas con otros miembros apasionados.\n\nEstamos deseando verte conseguir puntuaciones altas, avanzar por los niveles y alcanzar tus objetivos.\n\n¡Buena suerte y diviértete en nuestra comunidad gamificada!"
  }
}
